import { assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO__user_credentials } from '@shared/dto/+user/auth/DTO__user_credentials';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestAuthRegister extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_AUTH_REGISTER;

  credentials!: DTO__user_credentials;
  //key - EGenerationSettingType, value - update data
  language!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_type_enum(this.language, ENUM__language_type);
  }
}
